import Axios from 'axios';


var headers = {
    'Content-Type': 'application/json',


}
export default {

    
    getAll() {
        const BASE_URL = '/public/api';
        //console.log(BASE_URL)
        return Axios.get(BASE_URL + '/debtpayments', { headers: headers })
    },

    create(data) {
        const BASE_URL = '/public/api';
        return Axios.post(BASE_URL + '/debtpayments', data, { headers: headers });

    },

    update(id, data) {
        const BASE_URL = '/public/api';
        return Axios.put(BASE_URL + '/debtpayments/' + id, data, { headers: headers });
    },

    delete(id) {
        const BASE_URL = '/public/api';
        return Axios.delete(BASE_URL + '/debtpayments/' + id, { headers: headers });
    },

}